module.exports = __webpack_public_path__ + "static/media/ISO 27001.d9054783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ISO 27001.jpg
// module id = 1595
// module chunks = 0